import { useContext } from 'react';

import { NotificationsContext } from '../context';

export const useNotificationContext = () => useContext(NotificationsContext);
